import {environment} from '../environments/environment';

export const PO_DESTINATIONS = {
  'gogo': {
    'publishable': true
  },
  'dropbox_project_lambda': {
    'publishable': true
  },
  'aspera-anuvu-above-sna-integration': {
    'publishable': true
  },
  'pxcom_sftp': {
    'publishable': true
  },
  'pxcom_s3': {
    'publishable': true
  },
  'airbus': {
    'publishable': true
  },
  '1o1media': {
    'publishable': true
  },
  'displayinteractive': {
    'publishable': true
  },
  'panasonic': {
    'publishable': true
  },
  'manual_distribution': {
    'publishable': false
  },
  'safran': {
    'publishable': true
  },
  'safran-album': {
    'publishable': true
  },
  'lh_expedat_dl': {
    'publishable': true
  },
  'bluebox': {
    'publishable': true
  },
  'moment-tv': {
    'publishable': true
  },
  'moment-movie': {
    'publishable': true
  },
  'av_jet': {
    'publishable': true
  },
  'aerogroup': {
    'publishable': true
  },
  'aeroplay_entertainment': {
    'publishable': true
  },
  'aeroplay_entertainment_wb': {
    'publishable': true
  },
  'century_carnival': {
    'publishable': true
  },
  'cinesend': {
    'publishable': true
  },
  'euro_communications': {
    'publishable': true
  },
  'france_vision_services': {
    'publishable': true
  },
  'images_in_motion': {
    'publishable': true
  },
  'gee-anuvu': {
    'publishable': true
  },
  'inflight_dublin': {
    'publishable': true
  },
  'quivertree': {
    'publishable': true
  },
  'spafax': {
    'publishable': true
  },
  'stellar': {
    'publishable': true
  },
  'stellar-s3': {
    'publishable': true
  },
  'tap': {
    'publishable': true
  },
  'turkish_airlines': {
    'publishable': true
  },
  'virgin_atlantic': {
    'publishable': true
  },
  'west_entertainment': {
    'publishable': true
  },
  'thales_signiant': {
    'publishable': true
  },
  'thales_flytedge': {
    'publishable': true
  },
  'thales_fastpath': {
    'publishable': true
  },
  'difes': {
    'publishable': true
  },
  'delta_dfp_aspera': {
    'publishable': true
  },
  'burrana': {
    'publishable': true
  },
  'burrana-sftp': {
    'publishable': true
  },
  'dragonfly': {
    'publishable': true
  },
  'vod': {
    'publishable': true
  },
  'transperfect': {
    'publishable': true
  },
  'lilt': {
    'publishable': true
  },
  'aeroplay_entertainment_sj': {
    'publishable': true
  },
  'delta_intelsat_aspera': {
    'publishable': true
  },
  'viasat-wife': {
    'publishable': true
  },
  'conetic-internal-co': {
    'publishable': true
  },
  'conetic-external-ab': {
    'publishable': true
  },
  'conetic-external-aa': {
    'publishable': true
  },
}


const anuvu_airtime_dme = {
  item_id: 'anuvu_airtime_dme',
  item_text: 'Anuvu Airtime DME',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000s2.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'anuvu-airtime-dme',
  po_destinations: [
    {display_name: 'Anuvu Aspera Above SNA Integration', destination_id: 'aspera-anuvu-above-sna-integration'},
  ]
}

const panasonic_m1 = {
  item_id: 'panasonic_m1',
  item_text: 'M1',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000m1.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-m1',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_m2 = {
  item_id: 'panasonic_m2',
  item_text: 'M2',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000m2.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-m2',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}
const panasonic_m4 = {
  item_id: 'panasonic_m4',
  item_text: 'M4',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000m4.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-m4',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_h7 = {
  item_id: 'panasonic_h7',
  item_text: 'H7 *experimental*',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000h7.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-h7',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_h8 = {
  item_id: 'panasonic_h8',
  item_text: 'H8 *experimental*',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000h8.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-h8',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_h7_next = {
  item_id: 'panasonic_h7_next',
  item_text: 'H7-NEXT *experimental*',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000h7.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-h7-next',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_h8_next = {
  item_id: 'panasonic_h8_next',
  item_text: 'H8-NEXT *experimental*',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000h8.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-h8-next',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_k4 = {
  item_id: 'panasonic_k4',
  item_text: 'K4 (UHD, SDR) *experimental*',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000k4.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-k4',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_h4 = {
  item_id: 'panasonic_h4',
  item_text: 'H4 (UHD, HDR) *experimental*',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000h4.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-h4',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_z4 = {
  item_id: 'panasonic_z4',
  item_text: 'Z4',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000z4.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-z4',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_s2 = {
  item_id: 'panasonic_astrova_s2',
  item_text: 'ASTROVA S2',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000s2.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-s2',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_s2_crf = {
  item_id: 'panasonic_astrova_s2_crf',
  item_text: 'ASTROVA S2 CRF',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000s2.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-s2-crf',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_s7 = {
  item_id: 'panasonic_astrova_s7',
  item_text: 'ASTROVA S7',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000s7.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-s7',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_s7_crf = {
  item_id: 'panasonic_astrova_s7_crf',
  item_text: 'ASTROVA S7 CRF',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000s7.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-s7-crf',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_s8 = {
  item_id: 'panasonic_astrova_s8',
  item_text: 'ASTROVA S8',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000s8.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-s8',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_s8_crf = {
  item_id: 'panasonic_astrova_s8_crf',
  item_text: 'ASTROVA S8 CRF',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000s8.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-s8-crf',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_s4 = {
  item_id: 'panasonic_astrova_s4',
  item_text: 'ASTROVA S4 (UHD, SDR)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000s4.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-s4',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_s4_crf = {
  item_id: 'panasonic_astrova_s4_crf',
  item_text: 'ASTROVA S4 CRF (UHD, SDR)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000s4.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-s4-crf',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_r7 = {
  item_id: 'panasonic_astrova_r7',
  item_text: 'ASTROVA R7 (720p, HDR)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000r7.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-r7',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_r8 = {
  item_id: 'panasonic_astrova_r8',
  item_text: 'ASTROVA R8 (1080p, HDR)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000r8.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-r8',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_astrova_r4 = {
  item_id: 'panasonic_astrova_r4',
  item_text: 'ASTROVA R4 (UHD, HDR)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000r4.mp4',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'panasonic-astrova-r4',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_audio_wav = {
  audio_only: true,
  item_id: 'panasonic_audio_wav',
  item_text: 'AUDIO - WAV (Non-PRAM)',
  watermark: false,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000z4.wav',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'PANASONIC-AUDIO-WAV',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_audio_wav_pram = {
  audio_only: true,
  item_id: 'panasonic_audio_wav_pram',
  item_text: 'AUDIO - WAV (PRAM)',
  watermark: false,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000z4.wav',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'PANASONIC-AUDIO-WAV-PRAM',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_audio_abs = {
  audio_only: true,
  item_id: 'panasonic_audio_abs',
  item_text: 'AUDIO - ABS',
  watermark: false,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000z4.abs',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'PANASONIC-AUDIO-ABS',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_audio_mp3 = {
  audio_only: true,
  item_id: 'panasonic_audio_mp3',
  item_text: 'AUDIO - MP3',
  watermark: false,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000z4.mp3',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'PANASONIC-AUDIO-MP3',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

const panasonic_audio_aac = {
  audio_only: true,
  item_id: 'panasonic_audio_aac',
  item_text: 'AUDIO - AAC',
  watermark: false,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000z4.aac',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'PANASONIC-AUDIO-AAC',
  po_destinations: [
    {display_name: 'Panasonic via SJ', destination_id: 'panasonic'},
    {display_name: 'TAP via SJ', destination_id: 'tap'},
  ]
}

// Burrana (formerly Rockwell Collins) PAVES BDS/HDMS overhead system.
// Spec: Rockwell Collins 523-0818783 Rev 3. All profiles are MPEG-2 Transport Stream (.mpg).
// HDMS accepts 4:3 or 16:9; BDS is 4:3-only (its profiles fail on a 16:9 source).
const burrana_dest = {display_name: 'Burrana (SFTP)', destination_id: 'burrana-sftp'};

const burrana_hdms_mpeg1_sif = {
  item_id: 'burrana_hdms_mpeg1_sif',
  item_text: 'HDMS - MPEG-1 SIF (SD, 352x240)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000_sif.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'burrana-hdms-mpeg1-sif',
  po_destinations: [burrana_dest],
}

const burrana_hdms_mpeg2_d1 = {
  item_id: 'burrana_hdms_mpeg2_d1',
  item_text: 'HDMS - MPEG-2 Full-D1 (SD, 720x480)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000_d1.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'burrana-hdms-mpeg2-d1',
  po_destinations: [burrana_dest],
}

const burrana_hdms_mpeg2_720p = {
  item_id: 'burrana_hdms_mpeg2_720p',
  item_text: 'HDMS - MPEG-2 720p (HD, 1280x720)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000_m2hd.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'burrana-hdms-mpeg2-720p',
  po_destinations: [burrana_dest],
}

const burrana_hdms_h264_720p = {
  item_id: 'burrana_hdms_h264_720p',
  item_text: 'HDMS - H.264 720p (HD, 1280x720)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000_h264.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'burrana-hdms-h264-720p',
  po_destinations: [burrana_dest],
}

const burrana_bds_mpeg1_sif = {
  item_id: 'burrana_bds_mpeg1_sif',
  item_text: 'BDS - MPEG-1 SIF (SD, 352x240, 4:3)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000_bds_sif.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'burrana-bds-mpeg1-sif',
  po_destinations: [burrana_dest],
}

const burrana_bds_mpeg2_d1 = {
  item_id: 'burrana_bds_mpeg2_d1',
  item_text: 'BDS - MPEG-2 Full-D1 (SD, 720x480, 4:3)',
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000_bds_d1.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'burrana-bds-mpeg2-d1',
  po_destinations: [burrana_dest],
}

const zodiac_rave_remix_sd_va = {
  item_id: 'zodiac_rave_remix_sd_va',
  item_text: 'RAVE Remix SD VA (legacy/.mpg)',
  po_pattern: {
    pattern: /^(\d{2})(\d{2})_[^_]+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_EngSplEnS_Th.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'RAVE-REMIX-SD-VA',
  po_destinations: [{display_name: 'Safran via SJ', destination_id: 'safran'}]
}

const rave_audio_mp3 = {
  item_id: 'zodiac_rave_mp3',
  item_text: 'RAVE audio - MP3',
  audio_only: true,
  po_pattern: {
    pattern: /^(\d{2})(\d{2})_[^_/].+\/[^/]+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, an underscore, a human-readable name, a slash, and then the zip file name.',
  },
  watermark: true,
  filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_EngSplEnS_Th.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'rave-audio',
  po_destinations: [
    {display_name: 'Safran (Album-wise) via SJ', destination_id: 'safran-album'},
    {display_name: 'Safran via SJ', destination_id: 'safran'},
  ],
};

const rave_audio_bgm = {
  ...rave_audio_mp3,
  item_id: 'zodiac_rave_bgm',
  item_text: 'RAVE audio - BGM',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_001.mp3',
  vtk_template: 'rave-audio-bgm',
  po_destinations: [
    {display_name: 'Safran via SJ', destination_id: 'safran'},
  ],
}

const rave_audio_pram = {
  ...rave_audio_mp3,
  item_id: 'zodiac_rave_pram',
  item_text: 'RAVE audio - PRAM',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_Eng.mp3',
  vtk_template: 'rave-audio-pram',
  po_destinations: [
    {display_name: 'Safran via SJ', destination_id: 'safran'},
  ],
}

const rave_audio_speech = {
  ...rave_audio_mp3,
  item_id: 'zodiac_rave_speech',
  item_text: 'RAVE audio - Speech',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_01.mp3',
  vtk_template: 'rave-audio-speech',
  po_destinations: [
    {display_name: 'Safran (Album-wise) via SJ', destination_id: 'safran-album'},
  ],
}

const thales_mpeg1_ts = {
  item_id: 'thales-sd-mpeg1-ts',
  item_text: 'MPEG-1, TS *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}_15M4_FW23_lcaacdc.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-sd-mpeg1-ts',
  po_destinations: [{display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'}]
}

const thales_mpeg2_ts = {
  item_id: 'thales-sd-mpeg2-ts',
  item_text: 'MPEG-2, TS *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}_15M4_FW23_lcaacdc.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-sd-mpeg2-ts',
  po_destinations: [{display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'}]
}

const thales_sd_avc_ts = {
  item_id: 'thales-sd-avc-ts',
  item_text: 'SD, MPEG-4, TS *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}_15M4_FW23_lcaacdc.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-sd-avc-ts',
  po_destinations: [{display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'}]
}

const thales_720p_constrained_avc_ts = {
  item_id: 'thales-720p-constrained-avc-ts',
  item_text: '720p, constrained MPEG-4, TS *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}_15M4_FW23_lcaacdc.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-720p-constrained-avc-ts',
  po_destinations: [{display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'}]
}

const thales_720p_avc_ts = {
  item_id: 'thales-720p-avc-ts',
  item_text: '720p, MPEG-4, TS *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}_15M4_FW23_lcaacdc.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-720p-avc-ts',
  po_destinations: [{display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'}]
}

const thales_1080p_avc_ts = {
  item_id: 'thales-1080p-avc-ts',
  item_text: '1080p, MPEG-4, TS *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}_15M4_FW23_lcaacdc.mpg',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-1080p-avc-ts',
  po_destinations: [{display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'}]
}

const thales_avant_up_avod_hevc_540p = {
  item_id: 'thales-avant-up-avod-hevc-540p',
  item_text: '540p, HEVC, MPEG-DASH *experimental*',
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-avod-hevc-540p',
  po_destinations: [
    {display_name: 'Manual distribution', destination_id: 'manual_distribution'},
    {display_name: 'Thales fast-path', destination_id: 'thales_fastpath'},
  ],
  image_required: true,
}

const thales_avant_up_avod_hevc_720p = {
  item_id: 'thales-avant-up-avod-hevc-720p',
  item_text: '720p, HEVC, MPEG-DASH *experimental*',
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-avod-hevc-720p',
  po_destinations: [
    {display_name: 'Manual distribution', destination_id: 'manual_distribution'},
    {display_name: 'Thales fast-path', destination_id: 'thales_fastpath'},
  ],
  image_required: true,
}

const thales_avant_up_avod_hevc_1080p = {
  item_id: 'thales-avant-up-avod-hevc-1080p',
  item_text: '1080p, HEVC, MPEG-DASH *experimental*',
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-avod-hevc-1080p',
  po_destinations: [
    {display_name: 'Manual distribution', destination_id: 'manual_distribution'},
    {display_name: 'Thales fast-path', destination_id: 'thales_fastpath'},
  ],
  image_required: true,
}

if (!environment.production) {
  const publish_test = {
    display_name: 'Test publish to scratch bucket',
    destination_id: 'scratch',
  };
  thales_avant_up_avod_hevc_540p.po_destinations.push({...publish_test});
  thales_avant_up_avod_hevc_720p.po_destinations.push({...publish_test});
  thales_avant_up_avod_hevc_1080p.po_destinations.push({...publish_test});
  PO_DESTINATIONS['scratch'] = {publishable: true};
}

const thales_avant_up_hevc_480p = {
  item_id: 'thales-avant-up-hevc-480p',
  item_text: 'SD, HEVC *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-hevc-480p',
  po_destinations: [
    {display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'},
  ],
  image_required: false,
}

const thales_avant_up_hevc_480p_crf = {
  item_id: 'thales-avant-up-hevc-480p-crf',
  item_text: 'SD, HEVC, CRF *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-hevc-480p-crf',
  po_destinations: [
    {display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'},
  ],
  image_required: false,
}

const thales_avant_up_hevc_720p = {
  item_id: 'thales-avant-up-avod-hevc-720p',
  item_text: '720p, HEVC *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-hevc-720p',
  po_destinations: [
    {display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'},
  ],
  image_required: false,
}

const thales_avant_up_hevc_720p_crf = {
  item_id: 'thales-avant-up-avod-hevc-720p-crf',
  item_text: '720p, HEVC, CRF *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-hevc-720p-crf',
  po_destinations: [
    {display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'},
  ],
  image_required: false,
}

const thales_avant_up_hevc_1080p = {
  item_id: 'thales-avant-up-hevc-1080p',
  item_text: '1080p, HEVC *experimental*',
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-hevc-1080p',
  po_destinations: [
    {display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'},
  ],
  image_required: false,
}

const thales_avant_up_hevc_1080p_crf = {
  item_id: 'thales-avant-up-hevc-1080p-crf',
  item_text: '1080p, HEVC, CRF *experimental*',
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-hevc-1080p-crf',
  po_destinations: [
    {display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'},
  ],
  image_required: false,
}

const thales_avant_up_hevc_2160p = {
  item_id: 'thales-avant-up-hevc-2160p',
  item_text: '4K, HEVC *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-hevc-2160p',
  po_destinations: [
    {display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'},
  ],
  image_required: false,
}

const thales_avant_up_hevc_2160p_crf = {
  item_id: 'thales-avant-up-hevc-2160p-crf',
  item_text: '4K, HEVC, CRF *experimental*',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: true,
  filename: '${dirname}',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'thales-avant-up-hevc-2160p-crf',
  po_destinations: [
    {display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'},
  ],
  image_required: false,
}

const thales_audio_mp3 = {
  audio_only: true,
  item_id: 'thales-audio-mp3',
  item_text: 'Audio only, MP3',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_.+\/(.+)$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, an underscore, a human-readable name, a slash, and then the directory name.',
  },
  watermark: false,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000z4.mp3',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'THALES-AUDIO-MP3',
  po_destinations: [{display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'}]
}

const thales_audio_mp3_rms12 = {
  audio_only: true,
  item_id: 'thales-audio-mp3-rms12',
  item_text: 'Audio only, MP3 (Max peak -12dB RMS)',
  po_pattern: {
    pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
    pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
  },
  watermark: false,
  filename: '${customer.toLowerCase()}00${now.getUTCFullYear().toString().substring(2)}00000z4.mp3',
  metadata_source_type: null,
  wrap_up_workflow: null,
  require_metadata_reference: false,
  vtk_template: 'THALES-AUDIO-MP3-RMS12',
  po_destinations: [{display_name: 'Thales (via Signiant)', destination_id: 'thales_signiant'}]
}

export const THALES_SYSTEMS = [
  {
    item_id: 'ife_thales_all',
    item_text: 'Thales all',
    formats: [
      thales_mpeg1_ts,
      thales_mpeg2_ts,
      thales_sd_avc_ts,
      thales_720p_constrained_avc_ts,
      thales_720p_avc_ts,
      thales_1080p_avc_ts,
      thales_audio_mp3,
      thales_audio_mp3_rms12,
    ]
  },
  {
    item_id: 'ife_thales_avantup',
    item_text: 'Thales Avant Up *experimental*',
    formats: [
      thales_avant_up_hevc_480p,
      thales_avant_up_hevc_720p,
      thales_avant_up_hevc_1080p,
      thales_avant_up_hevc_2160p,
      thales_avant_up_hevc_480p_crf,
      thales_avant_up_hevc_720p_crf,
      thales_avant_up_hevc_1080p_crf,
      thales_avant_up_hevc_2160p_crf,
    ],
  },
  {
    item_id: 'ife_thales_avantup_dash',
    item_text: 'Thales Avant Up MPEG-DASH *experimental*',
    formats: [
      thales_avant_up_avod_hevc_540p,
      thales_avant_up_avod_hevc_720p,
      thales_avant_up_avod_hevc_1080p,
    ],
  },
]


export const DELTA_SYSTEMS = [{
  item_id: 'ife_delta_all',
  item_text: 'Delta all',
  formats: [
    {
      item_id: 'delta_dfp_vod',
      item_text: 'DFP VoD',
      watermark: true,
      filename: 'movie.mp4',
      metadata_source_type: null,
      wrap_up_workflow: null,
      require_metadata_reference: false,
      vtk_template: 'delta-dfp-vod',
      po_destinations: [
        {display_name: 'Delta DFP via Aspera', destination_id: 'delta_dfp_aspera'},
        {display_name: 'Manual Delivery via Touch (ask Castlabs for download)', destination_id: 'delta_dfp_touch'}
      ]
    },
    {
      item_id: 'delta_dfp_aod',
      item_text: 'DFP AoD',
      watermark: false,
      filename: 'audio.mp3',
      metadata_source_type: null,
      wrap_up_workflow: null,
      require_metadata_reference: false,
      audio_only: true,
      vtk_template: 'delta-dfp-aod',
      po_destinations: [
        {display_name: 'Delta DFP via Aspera', destination_id: 'delta_dfp_aspera'},
        {display_name: 'Manual Delivery via Touch (ask Castlabs for download)', destination_id: 'delta_dfp_touch'}
      ]
    },
    {
      item_id: 'delta_dfp_safety',
      item_text: 'DFP Safety',
      watermark: true,
      filename: 'movie.mp4',
      metadata_source_type: null,
      wrap_up_workflow: null,
      require_metadata_reference: false,
      vtk_template: 'delta-dfp-safety',
      po_destinations: [
        {display_name: 'Delta DFP via Aspera', destination_id: 'delta_dfp_aspera'},
        {display_name: 'Manual Delivery via Touch (ask Castlabs for download)', destination_id: 'delta_dfp_touch'}
      ]
    },
    {
      item_id: 'delta_dfp_safety_a321neo',
      item_text: 'DFP Safety (A321 NEO)',
      watermark: true,
      filename: 'movie.mp4',
      vtk_template: 'delta-dfp-safety-a321neo',
      po_destinations: [
        {display_name: 'Delta DFP via Aspera', destination_id: 'delta_dfp_aspera'},
        {display_name: 'Manual Delivery via Touch (ask Castlabs for download)', destination_id: 'delta_dfp_touch'}
      ]
    },
    {
      item_id: 'delta_intelsat_vod',
      item_text: 'intelsat VoD',
      watermark: true,
      filename: 'movie.mp4',
      metadata_source_type: null,
      wrap_up_workflow: null,
      require_metadata_reference: false,
      vtk_template: 'delta-intelsat-vod',
      po_destinations: [
        {
          display_name: 'Delta Intelsat via Aspera (ask Castlabs for download)',
          destination_id: 'delta_intelsat_aspera'
        },
      ]
    },
    {
      item_id: 'delta_intelsat_aod',
      item_text: 'intelsat AoD',
      watermark: true,
      filename: 'song.mp3',
      metadata_source_type: null,
      wrap_up_workflow: null,
      require_metadata_reference: false,
      audio_only: true,
      vtk_template: 'delta-intelsat-aod',
      po_destinations: [
        {
          display_name: 'Delta Intelsat via Aspera (ask Castlabs for download)',
          destination_id: 'delta_intelsat_aspera'
        },
      ]
    },
    {
      item_id: 'delta_intelsat_safety',
      item_text: 'intelsat Safety',
      watermark: true,
      filename: 'movie.mp4',
      metadata_source_type: null,
      wrap_up_workflow: null,
      require_metadata_reference: false,
      vtk_template: 'delta-intelsat-safety',
      po_destinations: [
        {
          display_name: 'Delta Intelsat via Aspera (ask Castlabs for download)',
          destination_id: 'delta_intelsat_aspera'
        },
      ]
    },
    {
      item_id: 'delta_intelsat_safety_a321neo',
      item_text: 'intelsat Safety (A321 NEO)',
      watermark: true,
      filename: 'movie.mp4',
      metadata_source_type: null,
      wrap_up_workflow: null,
      require_metadata_reference: false,
      vtk_template: 'delta-intelsat-safety-a321neo',
      po_destinations: [
        {
          display_name: 'Delta Intelsat via Aspera (ask Castlabs for download)',
          destination_id: 'delta_intelsat_aspera'
        },
      ]
    },
    {
      item_id: 'delta_flytedge',
      item_text: 'Delta FlytEdge',
      watermark: false,
      filename: 'movie.mp4',
      metadata_source_type: 'flytedge',
      wrap_up_workflow: 'flytedge',
      require_metadata_reference: true,
      vtk_template: 'delta-flytedge',
      po_destinations: [
        {display_name: 'Thales FlytEdge via Azure', destination_id: 'thales_flytedge'}
      ]
    },
  ]
}]

export interface IfeSystem {
  item_id: string;
  item_text: string;
  formats: IfeFormat[];
}

export interface IfeFormat {
  item_id: string;
  item_text: string;
  po_pattern: {
    pattern: RegExp | null;
    pattern_description: string;
  } | null
  watermark: boolean;
  filename: string;
  metadata_source_type: string | null,
  wrap_up_workflow: string | null,
  require_metadata_reference: boolean,
  vtk_template: string;
  po_destinations: PoDestination[];
  audio_only?: boolean;
  image_required?: boolean;
  // When true, the Encode ID may contain '/' as a path separator, so published
  // files nest into sub-folders (e.g. "FOO/BAR" -> flytedge/FOO/BAR/). Defaults to
  // false, which restricts the Encode ID to a single path segment.
  allow_path_in_encode_id?: boolean;
}

export interface PoDestination {
  display_name: string;
  destination_id: string;
  enabled?: boolean;
}

export const conetic_destinations: PoDestination[] = [
  {display_name: 'conetic_source', destination_id: 'conetic-internal-co', enabled: true},
  {display_name: 'conetic_ab', destination_id: 'conetic-external-ab', enabled: true},
  {display_name: 'conetic_aa', destination_id: 'conetic-external-aa', enabled: true},
];

// conetic-internal-co feeds Above's mezzanine copy into conetic's own input bucket -- only the
// Voyager Mezzanine format (which delivers that copy) should offer it. The encoded Voyager
// formats below deliver externally, so they have no business writing back to the source bucket.
export const conetic_voyager_encode_destinations: PoDestination[] = conetic_destinations.filter(
  d => d.destination_id !== 'conetic-internal-co'
);

// The inverse restriction: Voyager Mezzanine only ever writes the mezzanine copy back into
// conetic's own input bucket -- the external ab/aa buckets are for encoded Voyager output, never
// a raw mezzanine.
export const conetic_voyager_mezzanine_destinations: PoDestination[] = conetic_destinations.filter(
  d => d.destination_id === 'conetic-internal-co'
);

// Formats carry no fixed format_specific_data: a predefined format is its own vtkpy template.
// Voyager names conetic-voyager-*, whose DEFAULT_FORMAT_SPECIFIC_DATA holds the bandwidth-saver ladder
// (H.264/HEVC/AV1 at 640/864/1280) or the audio-only ladder, plus encrypt/onboard/thumbs.
// The capabilities endpoint publishes those defaults as `default_format_specific_data`.

export const ALL_SYSTEMS: IfeSystem[] = [].concat([
    {
      item_id: 'pxcom',
      item_text: 'PXCOM',
      formats: [{
        item_id: '480p',
        item_text: 'PXCOM 480p',
        po_pattern: {
          pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
          pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
        },
        watermark: true,
        filename: '[ROOT]',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'pxcom-480p',
        po_destinations: [
          {display_name: 'Deliver to PXCOM S3 (Default)', destination_id: 'pxcom_s3', enabled: true},
          {display_name: 'Deliver to PXCOM SFTP (Use for Disney Assets only)', destination_id: 'pxcom_sftp', enabled: true},
        ]
      }, {
        item_id: '720p',
        item_text: 'PXCOM 720p',
        po_pattern: {
          pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
          pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
        },
        watermark: true,
        filename: '[ROOT]',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'pxcom-720p',
        po_destinations: [
          {display_name: 'Deliver to PXCOM (S3)', destination_id: 'pxcom_s3', enabled: true},
          {display_name: 'Deliver to PXCOM (SFTP)', destination_id: 'pxcom_sftp', enabled: true},
        ]
      }, {
        item_id: '1080p',
        item_text: 'PXCOM 1080p',
        po_pattern: {
          pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
          pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
        },
        watermark: true,
        filename: '[ROOT]',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'pxcom-1080p',
        po_destinations: [
          {display_name: 'Deliver to PXCOM (S3)', destination_id: 'pxcom_s3', enabled: true},
          {display_name: 'Deliver to PXCOM (SFTP)', destination_id: 'pxcom_sftp', enabled: true},
        ]
      }, {
        item_id: 'pxcom_audio_mp3',
        item_text: 'PXCOM Audio MP3',
        audio_only: true,
        po_pattern: {
          pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
          pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
        },
        watermark: true,
        filename: '[ROOT]',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'pxcom-audio-mp3',
        po_destinations: [
          {display_name: 'Deliver to PXCOM (S3)', destination_id: 'pxcom_s3', enabled: true},
          {display_name: 'Deliver to PXCOM (SFTP)', destination_id: 'pxcom_sftp', enabled: true},
        ]
      },
      ]
    }, {
      item_id: 'ife-dmr',
      item_text: 'IFE DMR',
      formats: [{
        item_id: 'ife-dmr-h264-sd',
        item_text: 'IFE DMR H.264 SD',
        watermark: true,
        filename: 'out.mpg',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'ife-dmr-h264-sd',
        po_destinations: [
          {display_name: 'Deliver to IFE DMR (manual)', destination_id: 'manual_distribution', enabled: true},
        ]
      }, {
        item_id: 'ife-dmr-h264-hd',
        item_text: 'IFE DMR H.264 HD',
        watermark: true,
        filename: 'out.mpg',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'ife-dmr-h264-hd',
        po_destinations: [
          {display_name: 'Deliver to IFE DMR (manual)', destination_id: 'manual_distribution', enabled: true},
        ]
      }
      ]
    },
    {
      item_id: 'conetic_voyager_all',
      item_text: 'Conetic Voyager All',
      formats: [{
        item_id: 'conetic_voyager_bandwidth_saver_drm',
        item_text: 'Bandwidth Saver (H.264/HEVC/AV1, DRM)',
        watermark: false,
        filename: '{customer}00{year}_voyager_bandwidth_saver_drm',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'conetic-voyager-bandwidth-saver-drm',
        po_destinations: conetic_voyager_encode_destinations,
      }, {
        item_id: 'conetic_voyager_bandwidth_saver',
        item_text: 'Bandwidth Saver (H.264/HEVC/AV1, no DRM)',
        watermark: false,
        filename: '{customer}00{year}_voyager_bandwidth_saver',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'conetic-voyager-bandwidth-saver',
        po_destinations: conetic_voyager_encode_destinations,
      }, {
        item_id: 'conetic_voyager_audio_drm',
        item_text: 'Audio Only (DRM)',
        audio_only: true,
        watermark: false,
        filename: '{customer}00{year}_voyager_audio_drm',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'conetic-voyager-audio-drm',
        po_destinations: conetic_voyager_encode_destinations,
      }, {
        item_id: 'conetic_voyager_audio',
        item_text: 'Audio Only (no DRM)',
        audio_only: true,
        watermark: false,
        filename: '{customer}00{year}_voyager_audio',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'conetic-voyager-audio',
        po_destinations: conetic_voyager_encode_destinations,
      }, {
        item_id: 'conetic_voyager_mezzanine',
        item_text: 'Mezzanine (copy source as is)',
        watermark: false,
        filename: '{customer}00{year}_voyager_mezzanine.mp4',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'mezzanine_default',
        po_destinations: conetic_voyager_mezzanine_destinations,
      }]
    },
    {
      item_id: 'viasat-wife',
      item_text: 'Viasat W-IFE',
      formats: [{
        item_id: 'viasat-wife-sd',
        item_text: 'Viasat W-IFE SD',
        watermark: true,
        filename: 'out.mp4',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'viasat-wife-sd',
        po_destinations: [
          {display_name: 'Stellar (SmartJog)', destination_id: 'stellar', enabled: true},
          {display_name: 'Stellar (S3)', destination_id: 'stellar-s3', enabled: true},
          {display_name: 'Viasat manual download (Cyberduck)', destination_id: 'viasat-wife', enabled: true},
        ]
      }, {
        item_id: 'viasat-wife-720p',
        item_text: 'Viasat W-IFE 720p',
        watermark: true,
        filename: 'out.mp4',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'viasat-wife-720p',
        po_destinations: [
          {display_name: 'Deliver to Viasat (manual)', destination_id: 'manual_distribution', enabled: true},
          {display_name: 'Viasat manual download (Cyberduck)', destination_id: 'viasat-wife', enabled: true},
        ]
      }
      ]
    },
    {
      item_id: 'immfly',
      item_text: 'Immfly',
      formats: [{
        item_id: 'immfly-480p',
        item_text: 'Immfly 480p',
        watermark: true,
        filename: 'out.mp4',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'immfly-480p',
        po_destinations: [
          {display_name: 'Quivertree via Smartjog', destination_id: 'quivertree-sj'},
        ]
      }, {
        item_id: 'immfly-1080p',
        item_text: 'Immfly 1080p',
        watermark: true,
        filename: 'out.mp4',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'immfly-1080p',
        po_destinations: [
          {display_name: 'Quivertree via Smartjog', destination_id: 'quivertree-sj'},
        ]
      }]
    },
    {
      item_id: 'aeapp',
      item_text: 'AEApp',
      formats: [{
        item_id: 'aeapp_m4v',
        item_text: 'AEApp M4V',
        watermark: true,
        filename: 'movie.m4v',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'aeapp-m4v',
        po_destinations: [{display_name: 'Manual distribution', destination_id: 'manual_distribution', enabled: true}]
      }]
    },
    {
      item_id: 'aeroplay',
      item_text: 'AeroPlay',
      formats: [{
        item_id: 'aeroplay_aerohub',
        item_text: 'AeroHub *experimental*',
        watermark: true,
        filename: 'movie.mp4',
        metadata_source_type: null,
        wrap_up_workflow: null,
        require_metadata_reference: false,
        vtk_template: 'aeroplay-aerohub',
        po_destinations: [
          {display_name: 'Aeroplay (SJ)', destination_id: 'aeroplay_entertainment_sj'},
          {display_name: 'Aeroplay (S3)', destination_id: 'aeroplay_entertainment'},
          {display_name: 'Aeroplay WB (S3)', destination_id: 'aeroplay_entertainment_wb'},
        ]
      }]
    },
    {
      item_id: 'ife_anuvu_airtime_dme',
      item_text: 'Anuvu Airtime DME',
      formats: [
        anuvu_airtime_dme,
      ]
    },
    {
      item_id: 'ife_panasonic_all',
      item_text: 'Panasonic all',
      formats: [
        panasonic_m1,
        panasonic_m2,
        panasonic_m4,
        panasonic_h7,
        panasonic_h7_next,
        panasonic_h8,
        panasonic_h8_next,
        panasonic_k4,
        panasonic_h4,
        panasonic_z4,
        panasonic_astrova_s2,
        panasonic_astrova_s7,
        panasonic_astrova_s8,
        panasonic_astrova_s4,
        panasonic_astrova_s2_crf,
        panasonic_astrova_s7_crf,
        panasonic_astrova_s8_crf,
        panasonic_astrova_s4_crf,
        panasonic_astrova_r7,
        panasonic_astrova_r8,
        panasonic_astrova_r4,
        panasonic_audio_wav,
        panasonic_audio_wav_pram,
        panasonic_audio_abs,
        panasonic_audio_mp3,
        panasonic_audio_aac,
      ]
    },
    {
      item_id: 'ife_panasonic_audio_only',
      item_text: 'Panasonic audio only',
      formats: [
        panasonic_audio_wav,
        panasonic_audio_wav_pram,
        panasonic_audio_abs,
        panasonic_audio_mp3,
        panasonic_audio_aac,
      ]
    },
    {
      item_id: 'ife_burrana_all',
      item_text: 'Burrana (PAVES BDS/HDMS)',
      formats: [
        burrana_hdms_mpeg1_sif,
        burrana_hdms_mpeg2_d1,
        burrana_hdms_mpeg2_720p,
        burrana_hdms_h264_720p,
        burrana_bds_mpeg1_sif,
        burrana_bds_mpeg2_d1,
      ]
    }],
  THALES_SYSTEMS,
  [{
    item_id: 'ife_gogo', item_text: 'Gogo',
    formats: [{
      item_id: 'gogo_generic',
      item_text: 'Generic',
      watermark: true,
      filename: '${dirname}.mp4',
      metadata_source_type: null,
      wrap_up_workflow: null,
      require_metadata_reference: false,
      vtk_template: 'GOGO',
      po_destinations: [{display_name: 'Manual Delivery via Aspera (ask Castlabs for download)', destination_id: 'gogo'}]
    }],
  },
    {
      item_id: 'ife_lambda_jetpack', item_text: 'Lambda JetPack',
      formats: [
        {
          item_id: 'jetpack-480p',
          item_text: 'JetPack 480p',
          watermark: false,
          filename: 'FILMNAME_AIRLINECODE_CYCLEDATE_LANGUAGETRACKS.m4v',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'lambda-jetpack-480p',
          po_destinations: [{display_name: 'DropBox', destination_id: 'dropbox_project_lambda'}]
        },
        {
          item_id: 'jetpack-1080',
          item_text: 'JetPack 1080 HEVC',
          watermark: true,
          filename: 'XYZ_${dirname}_00${now.getUTCFullYear().toString().substring(2)}_EngCsp.m4v',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'lambda-jetpack-1080p-hevc',
          po_destinations: [{display_name: 'DropBox', destination_id: 'dropbox_project_lambda'}]
        }],
    },
    {
      item_id: 'ife_zodiac_rave', item_text: 'Safran',
      formats: [
        {
          item_id: 'zodiac_rave_sd_nl',
          item_text: 'RAVE SD (Filename update 12.25)',
          po_pattern: {
            pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
            pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
          },
          watermark: true,
          filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_MV_SD.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'RAVE-SD-simple-filename',
          po_destinations: [
            {display_name: 'Safran via SJ', destination_id: 'safran'},
          ]
        },
        {
          item_id: 'zodiac_rave_720p_nl',
          item_text: 'RAVE HD 720p (Filename update 12.25)',
          po_pattern: {
            pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
            pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
          },
          watermark: true,
          filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_MV_HD.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'RAVE-720P-simple-filename',
          po_destinations: [
            {display_name: 'Safran via SJ', destination_id: 'safran'},
          ]
        },
        {
          item_id: 'zodiac_rave_1080p_nl',
          item_text: 'RAVE HD 1080p (Filename update 12.25)',
          po_pattern: {
            pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
            pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
          },
          watermark: true,
          filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_MV_HD.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'RAVE-1080P-simple-filename',
          po_destinations: [{display_name: 'Safran via SJ', destination_id: 'safran'}]
        },

        {
          item_id: 'zodiac_rave_sd',
          item_text: 'RAVE SD (Legacy names with audio languages)',
          po_pattern: {
            pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
            pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
          },
          watermark: true,
          filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_EngSplEnS_Th.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'RAVE-SD',
          po_destinations: [
            {display_name: 'Safran via SJ', destination_id: 'safran'},
          ]
        },
        {
          item_id: 'zodiac_rave_720p',
          item_text: 'RAVE HD 720p (Legacy names with audio languages)',
          po_pattern: {
            pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
            pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
          },
          watermark: true,
          filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_EngSplEnS_Th.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'RAVE-720P',
          po_destinations: [
            {display_name: 'Safran via SJ', destination_id: 'safran'},
          ]
        },
        {
          item_id: 'zodiac_rave_1080p',
          item_text: 'RAVE HD 1080p (Legacy names with audio languages)',
          po_pattern: {
            pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
            pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
          },
          watermark: true,
          filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_EngSplEnS_Th.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'RAVE-1080P',
          po_destinations: [{display_name: 'Safran via SJ', destination_id: 'safran'}]
        },

        {
          item_id: 'zodiac_rave_audio',
          item_text: 'RAVE audio',
          po_pattern: {
            pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
            pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
          },
          watermark: true,
          filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_EngSplEnS_Th.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'RAVE-SD',
          po_destinations: [{display_name: 'Safran via SJ', destination_id: 'safran'}]
        },

        {
          item_id: 'zodiac_rave_sd_va',
          item_text: 'RAVE SD VA',
          po_pattern: {
            pattern: /^(0[1-9]|1[0-2])(2[5-9]|[3-9][0-9])_[^_].+$/,
            pattern_description: 'The PO number must start with a 2-digit month followed by a 2-digit year, followed by an underscore, followed by a human readable name of the content.',
          },
          watermark: true,
          filename: 'XYZ_00${now.getUTCFullYear().toString().substring(2)}_${dirname}_EngSplEnS_Th.mpg',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'RAVE-SD-VA',
          po_destinations: [{display_name: 'Safran via SJ', destination_id: 'safran'}]
        },
        rave_audio_mp3,
        rave_audio_bgm,
        rave_audio_pram,
        rave_audio_speech,
        zodiac_rave_remix_sd_va
      ]
    },
    {
      item_id: 'ife_airfi', item_text: 'AirFi',
      formats: [
        {
          item_id: 'airfi_mp4',
          item_text: 'Non-adaptive',
          watermark: true,
          filename: '${dirname}.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'AIRFI-MP4',
          po_destinations: [{display_name: 'WestEnt via Signiant', destination_id: 'airfi_via_west'}]
        },
        {
          item_id: 'airfi_mp4_new',
          item_text: 'Non-adaptive, Updated Spec',
          watermark: true,
          filename: '${dirname}.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'AIRFI-MP4-NEW',
          po_destinations: [{display_name: 'WestEnt via Signiant', destination_id: 'airfi_via_west'}]
        },
        {
          item_id: 'airfi_drm',
          item_text: 'DRM profile',
          watermark: true,
          filename: '${dirname}.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'AIRFI-DRM',
          po_destinations: [{display_name: 'WestEnt via Signiant', destination_id: 'airfi_via_west'}]
        },
        {
          item_id: 'airfi_aion_480p',
          item_text: 'AION 480p',
          watermark: true,
          filename: '${dirname}.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'airfi-aion-480p',
          po_destinations: [
            {display_name: 'WestEnt via Signiant', destination_id: 'airfi_via_west'},
            {display_name: 'Quivertree via Smartjog', destination_id: 'quivertree-sj'},
          ]
        },
        {
          item_id: 'airfi_aion_576p',
          item_text: 'AION 576p',
          watermark: true,
          filename: '${dirname}.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'airfi-aion-576p',
          po_destinations: [
            {display_name: 'WestEnt via Signiant', destination_id: 'airfi_via_west'},
            {display_name: 'Quivertree via Smartjog', destination_id: 'quivertree-sj'},
          ]
        },
        {
          item_id: 'airfi_aion_720p',
          item_text: 'AION 720p',
          watermark: true,
          filename: '${dirname}.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'airfi-aion-720p',
          po_destinations: [
            {display_name: 'WestEnt via Signiant', destination_id: 'airfi_via_west'},
            {display_name: 'Quivertree via Smartjog', destination_id: 'quivertree-sj'},
          ]
        },
        {
          item_id: 'airfi_aion_1080p',
          item_text: 'AION 1080p',
          watermark: true,
          filename: '${dirname}.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'airfi-aion-1080p',
          po_destinations: [
            {display_name: 'WestEnt via Signiant', destination_id: 'airfi_via_west'},
            {display_name: 'Quivertree via Smartjog', destination_id: 'quivertree-sj'},
          ]
        },
      ]
    },
    {
      item_id: 'ife_bc_cmaf', item_text: 'BoardConnect-CMAF',
      formats: [
        {
          item_id: 'bc_cmaf_p',
          item_text: 'BoardConnect-CMAF',
          watermark: false,
          filename: '00000000-0000-0000-0000-000000000000_${customer.toUpperCase()}__${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          output_file: '${filename}',
          vtk_template: 'bc_cmaf_p',
          po_destinations: [{display_name: 'Expedat download', destination_id: 'lh_expedat_dl'}]
        },
        {
          item_id: 'bc_cmafhd_p',
          item_text: 'BoardConnect-CMAF_HD',
          watermark: false,
          filename: '00000000-0000-0000-0000-000000000000_${customer.toUpperCase()}__${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          output_file: '${filename}',
          vtk_template: 'bc_cmafhd_p',
          po_destinations: [{display_name: 'Expedat download', destination_id: 'lh_expedat_dl'}]
        },
        {
          item_id: 'bc_cmaf_u',
          item_text: 'BoardConnect-CMAF-Clear',
          watermark: false,
          filename: '00000000-0000-0000-0000-000000000000_${customer.toUpperCase()}__${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          output_file: '${filename}',
          vtk_template: 'bc_cmaf_u',
          po_destinations: [{display_name: 'Expedat download', destination_id: 'lh_expedat_dl'}]
        },
        {
          item_id: 'bc_cmafhd_u',
          item_text: 'BoardConnect-CMAF_HD-Clear',
          watermark: false,
          filename: '00000000-0000-0000-0000-000000000000_${customer.toUpperCase()}__${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          output_file: '${filename}',
          vtk_template: 'bc_cmafhd_u',
          po_destinations: [{display_name: 'Expedat download', destination_id: 'lh_expedat_dl'}]
        },
      ]
    },
    {
      item_id: 'ife_bc_cmaf_hd', item_text: 'BoardConnect-CMAF_HD',
      formats: [
        {
          item_id: 'bc_cmafhd_p',
          item_text: 'BoardConnect-CMAF_HD',
          watermark: false,
          filename: '00000000-0000-0000-0000-000000000000_${customer.toUpperCase()}__${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          output_file: '${filename}',
          vtk_template: 'bc_cmafhd_p',
          po_destinations: [{display_name: 'Expedat download', destination_id: 'lh_expedat_dl'}]
        },
        {
          item_id: 'bc_cmafhd_u',
          item_text: 'BoardConnect-CMAF_HD-Clear',
          watermark: false,
          filename: '00000000-0000-0000-0000-000000000000_${customer.toUpperCase()}__${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          output_file: '${filename}',
          vtk_template: 'bc_cmafhd_u',
          po_destinations: [{display_name: 'Expedat download', destination_id: 'lh_expedat_dl'}]
        },
      ]
    },
    {
      item_id: 'ife_nicemedia', item_text: 'Nicemedia',
      formats: [
        {
          item_id: 'nice_media',
          item_text: 'NiceMedia',
          watermark: false,
          filename: '00000000-0000-0000-0000-000000000000_${customer.toUpperCase()}__${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          output_file: '${filename}',
          vtk_template: 'nice_media',
          po_destinations: [{display_name: 'Expedat download', destination_id: 'lh_expedat_dl'}]
        },
      ]
    },
    {
      item_id: 'ife_bluebox', item_text: 'Bluebox',
      formats: [
        {
          item_id: 'bluebox_wow',
          item_text: 'Bluebox Wow',
          watermark: true,
          filename: '${dirname}.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'BlueboxWow',
          po_destinations: [{display_name: 'Bluebox via SJ', destination_id: 'bluebox'}]
        },
        {
          item_id: 'bluebox_ai',
          item_text: 'Bluebox Ai',
          watermark: true,
          filename: '${dirname}.m4v',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'BlueboxAi',
          po_destinations: [{display_name: 'Bluebox via SJ', destination_id: 'bluebox'}]
        },
      ]
    },
    {
      item_id: 'ife_moment', item_text: 'Moment',
      formats: [
        {
          item_id: 'moment_720p',
          item_text: 'Moment 720p',
          watermark: true,
          filename: '${dirname}.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'Moment_720p',
          po_destinations: [
            {display_name: 'Moment TV shows', destination_id: 'moment-tv'},
            {display_name: 'Moment Movies', destination_id: 'moment-movie'}
          ]
        },
        {
          item_id: 'moment_flymingo',
          item_text: 'Moment Flymingo',
          watermark: true,
          filename: '${dirname}.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'moment_flymingo',
          po_destinations: [
            {display_name: 'Moment TV shows', destination_id: 'moment-tv'},
            {display_name: 'Moment Movies', destination_id: 'moment-movie'}
          ]
        },
      ]
    },
    {
      item_id: 'ife_everhub', item_text: 'Everhub', formats: [
        {
          item_id: 'everhub_tv_int_movies_stream1',
          item_text: 'TV & International Movies Stream 1 (1M)',
          watermark: true,
          filename: 'lotm02{now.getUTCFullYear().toString().substring(2)}00000m4_1M.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'everhub-tv-int-movies-stream1',
          po_destinations: [
            {display_name: 'Inflight Dublin', destination_id: 'inflight_dublin'},
          ],
        },
        {
          item_id: 'everhub_tv_int_movies_stream2',
          item_text: 'TV & International Movies Stream 2 (512k)',
          watermark: true,
          filename: 'lotm02{now.getUTCFullYear().toString().substring(2)}00000m4_512K.mp4',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'everhub-tv-int-movies-stream2',
          po_destinations: [
            {display_name: 'Inflight Dublin', destination_id: 'inflight_dublin'},
          ],
        }
      ]
    },
    {
      item_id: 'above_mezzanine', item_text: 'Mezzanine Delivery', formats: [
        {
          item_id: 'above_mezzanine_default',
          item_text: 'Copy source files as is',
          watermark: false,
          filename: '',
          vtk_template: 'mezzanine_default',
          po_destinations: [
            {display_name: 'AV jet', destination_id: 'av_jet'},
            {display_name: 'Aerogroup', destination_id: 'aerogroup'},
            {display_name: 'Aeroplay Entertainment (S3)', destination_id: 'aeroplay_entertainment'},
            {display_name: 'Aeroplay Entertainment WB (S3)', destination_id: 'aeroplay_entertainment_wb'},
            {display_name: 'Aeroplay Entertainment (SJ)', destination_id: 'aeroplay_entertainment_sj'},
            {display_name: 'Burrana (SJ)', destination_id: 'burrana'},
            {display_name: 'Century Carnival', destination_id: 'century_carnival'},
            {display_name: 'Cinesend', destination_id: 'cinesend'},
            {display_name: 'Euro Communications', destination_id: 'euro_communications'},
            {display_name: 'France Vision Services', destination_id: 'france_vision_services'},
            {display_name: 'GEE-ANUVU', destination_id: 'gee-anuvu'},
            {display_name: 'Images in Motion', destination_id: 'images_in_motion'},
            {display_name: 'Inflight Dublin', destination_id: 'inflight_dublin'},
            {display_name: 'Quivertree via Expedat', destination_id: 'quivertree'},
            {display_name: 'Spafax', destination_id: 'spafax'},
            {display_name: 'Stellar (SmartJog)', destination_id: 'stellar'},
            {display_name: 'Stellar (S3)', destination_id: 'stellar-s3'},
            {display_name: 'TAP', destination_id: 'tap'},
            {display_name: 'Turkish Airlines', destination_id: 'turkish_airlines'},
            {display_name: 'Virgin Atlantic', destination_id: 'virgin_atlantic'},
            {display_name: 'West Entertainment', destination_id: 'west_entertainment'},
            {display_name: 'Digital IFE Services', destination_id: 'difes'},
          ]
        },
        {
          item_id: 'above_mezzanine_no_video',
          item_text: 'Copy source files as is (No video)',
          watermark: false,
          filename: '',
          audio_only: true,
          vtk_template: 'mezzanine_default',
          po_destinations: [
            {display_name: 'AV jet', destination_id: 'av_jet'},
            {display_name: 'Aerogroup', destination_id: 'aerogroup'},
            {display_name: 'Aeroplay Entertainment (S3)', destination_id: 'aeroplay_entertainment'},
            {display_name: 'Aeroplay Entertainment WB (S3)', destination_id: 'aeroplay_entertainment_wb'},
            {display_name: 'Aeroplay Entertainment (SJ)', destination_id: 'aeroplay_entertainment_sj'},
            {display_name: 'Burrana (SJ)', destination_id: 'burrana'},
            {display_name: 'Century Carnival', destination_id: 'century_carnival'},
            {display_name: 'Cinesend', destination_id: 'cinesend'},
            {display_name: 'Euro Communications', destination_id: 'euro_communications'},
            {display_name: 'France Vision Services', destination_id: 'france_vision_services'},
            {display_name: 'GEE-ANUVU', destination_id: 'gee-anuvu'},
            {display_name: 'Images in Motion', destination_id: 'images_in_motion'},
            {display_name: 'Inflight Dublin', destination_id: 'inflight_dublin'},
            {display_name: 'Quivertree via Expedat', destination_id: 'quivertree'},
            {display_name: 'Spafax', destination_id: 'spafax'},
            {display_name: 'Stellar (SmartJog)', destination_id: 'stellar'},
            {display_name: 'Stellar (S3)', destination_id: 'stellar-s3'},
            {display_name: 'TAP', destination_id: 'tap'},
            {display_name: 'Turkish Airlines', destination_id: 'turkish_airlines'},
            {display_name: 'Virgin Atlantic', destination_id: 'virgin_atlantic'},
            {display_name: 'West Entertainment', destination_id: 'west_entertainment'},
            {display_name: 'Digital IFE Services', destination_id: 'difes'},
          ]
        },
        {
          item_id: 'above_mezzanine_remux',
          item_text: 'Remux to .mov/.aif',
          watermark: false,
          filename: '${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'mezzanine_remux',
          po_destinations: [
            {display_name: 'AV jet', destination_id: 'av_jet'},
            {display_name: 'Aerogroup', destination_id: 'aerogroup'},
            {display_name: 'Aeroplay Entertainment (S3)', destination_id: 'aeroplay_entertainment'},
            {display_name: 'Aeroplay Entertainment WB (S3)', destination_id: 'aeroplay_entertainment_wb'},
            {display_name: 'Aeroplay Entertainment (SJ)', destination_id: 'aeroplay_entertainment_sj'},
            {display_name: 'Century Carnival', destination_id: 'century_carnival'},
            {display_name: 'Cinesend', destination_id: 'cinesend'},
            {display_name: 'Euro Communications', destination_id: 'euro_communications'},
            {display_name: 'France Vision Services', destination_id: 'france_vision_services'},
            {display_name: 'GEE-ANUVU', destination_id: 'gee-anuvu'},
            {display_name: 'Images in Motion', destination_id: 'images_in_motion'},
            {display_name: 'Inflight Dublin', destination_id: 'inflight_dublin'},
            {display_name: 'Quivertree via Expedat', destination_id: 'quivertree'},
            {display_name: 'Spafax', destination_id: 'spafax'},
            {display_name: 'Stellar', destination_id: 'stellar'},
            {display_name: 'TAP', destination_id: 'tap'},
            {display_name: 'Turkish Airlines', destination_id: 'turkish_airlines'},
            {display_name: 'Virgin Atlantic', destination_id: 'virgin_atlantic'},
            {display_name: 'West Entertainment', destination_id: 'west_entertainment'},
            {display_name: 'Digital IFE Services', destination_id: 'difes'},
          ]
        },
        {
          item_id: 'above_mezzanine_flytedge',
          item_text: 'Mezzanine to FlytEdge',
          watermark: false,
          filename: '${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'to-flytedge-mezzanine',
          allow_path_in_encode_id: true,
          po_destinations: [
            {display_name: 'FlytEdge (Internal S3)', destination_id: 'flytedge_s3'}
          ]
        },
        {
          item_id: 'translation_proxy',
          item_text: 'Translation Proxy',
          watermark: false,
          filename: 'OrderID_${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'translation_proxy',
          po_destinations: [
            {display_name: 'TransPerfect (SFTP)', destination_id: 'transperfect'},
            {display_name: 'Lilt', destination_id: 'lilt'},
          ]
        },
        {
          item_id: 'above_difes',
          item_text: 'Difes Proxy',
          watermark: false,
          filename: '${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'mezzanine_difes',
          po_destinations: [
            {display_name: 'Difes', destination_id: 'difes'}
          ]
        }
      ]
    },
    {
      item_id: 'ife_stellar',
      item_text: 'Stellar',
      formats: [
        // fixme 2025-06-16: should this be part of above_mezzanine?
        {
          item_id: 'stellar_video',
          item_text: 'Video',
          watermark: false,
          filename: '${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'stellar-video',
          po_destinations: [
            {display_name: 'Stellar (S3)', destination_id: 'stellar-s3'},
          ]
        },
      ],
    },
    {
      item_id: 'donica',
      item_text: 'Donica',
      formats: [
        {
          item_id: 'donica_sd',
          item_text: 'SD',
          filename: '${dirname}',
          metadata_source_type: null,
          wrap_up_workflow: null,
          require_metadata_reference: false,
          vtk_template: 'donica-sd',
          po_destinations: [
            {display_name: 'Inflight Dublin', destination_id: 'inflight_dublin'},
          ]
        }
      ]
    }
  ], DELTA_SYSTEMS).sort((a, b) => a.item_text.localeCompare(b.item_text));
